export enum TableCellTypes {
  Image,
  Label,
  LabelDivided,
  Status,
  Icon,
  OpenButton,
  LabelWithIcon,
  Text
}